import Layout from '@/components/Layout';

export default function TestComponents() {
  return (
    <Layout pageName="Test">
      <div>Test components here</div>
    </Layout>
  );
}
